import { useParams, useOutlet } from 'react-router-dom';
import List from 'components/Conversation/List';

function Index() {
  const { encodedResourceId } = useParams();
  const outlet = useOutlet();

  return (
    <div className="relative flex-1 -m-5 lg:-m-6">
      <div className="absolute inset-0 flex overflow-hidden">
        <div className={`flex flex-col w-full lg:w-[340px] lg:min-w-[300px] border-r border-base-200 lg:flex-shrink-0 overflow-hidden ${encodedResourceId ? 'hidden lg:flex' : 'flex'}`}>
          <div className="px-4 py-3 text-lg font-semibold border-b border-base-200">
            Inbox
          </div>
          <List />
        </div>

        <div className={`flex-1 flex flex-col min-w-0 overflow-hidden ${encodedResourceId ? 'flex' : 'hidden lg:flex'}`}>
          {outlet ?? (
            <div className="flex-1 flex items-center justify-center text-base-content/40 text-sm select-none">
              Select a conversation to open the chat
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Index
